import React, { useRef, useEffect, useCallback, useState} from 'react';
import {
    setYearExploring,
    setSourceExploring} from 'actions/index.js';
import SourceSamples from "./SourceSamples.js";
import Colors from 'components/Colors.js';
import {trim} from "utils/trim.js";
import VisualLink from './VisualLink.js';
import {useWindowManager} from 'components/windows/useWindowManager.js';
import {connect} from 'react-redux';
import ethereum from "decentralized/ethereum.js";
import '../../Xanadu.scss';

const colors = new Colors();

const SourceExploring = ({sequencerEngine, sourceExploring, setYearExploring, setSourceExploring}) => { 
    let ref = useRef(undefined);
    let [styles, setStyles] = useState([]);

    const {setCoords, onMouseUp, onMouseDown, coords} =
          useWindowManager({ref});

    useEffect(() => {
        if (sourceExploring) {
            ethereum.guildSamples.getStylesForSound(sourceExploring.getId())
                .then(setStyles);
        }
    }, [sourceExploring, setStyles]);

    if (!sourceExploring) { return []; }
    let thumb = sourceExploring.getThumbnail();
    return [
        <div
          key={1}
          ref={ref}
          onMouseUp={onMouseUp}
          onMouseDown={onMouseDown}
          style={coords ? {top: coords.y, left: coords.x} : {}} className="source-exploring no-select">
          <div onClick={() => setSourceExploring(undefined)} className="clear-btn">x</div>
          <div className="source-top">
            {thumb ?
             <div className="cover-art" style={{backgroundImage: 'url(' + thumb + ')'}}/> :
             <div
               style={{backgroundColor: colors.getColorForHash(sourceExploring.getId())}}
               className="cover-art"/>}
            <div className="source-info">
              <div className="release-name">
                {sourceExploring.releaseName === "" ?
                 trim(sourceExploring.name) : trim(sourceExploring.releaseName)}
              </div>
              <div className="artist-name">
                {trim(sourceExploring.artistName)}
              </div>
              <div
                onClick={() => setYearExploring(sourceExploring.year)}
                className="release-year">
                {sourceExploring.year !== 0 && sourceExploring.year}
              </div>
              <div className="styles">
                {styles.map(x => <span key={x}>{x}</span>)}
              </div>
            </div>
          </div>
          <SourceSamples
            sequencerEngine={sequencerEngine}
            sample={sourceExploring}/>
        </div>,
        <VisualLink key={2} setCoords={setCoords} coords={coords} sample={sourceExploring}/>
    ];
}

const mapStateToProps = (state, props) => {
  return {
      sourceExploring: state.selector.sourceExploring
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSourceExploring: x => dispatch(setSourceExploring(x)),
      setYearExploring: x => dispatch(setYearExploring(x)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SourceExploring);
